import React, { Component } from "react";
import R14, { Text, Image, StyleSheet, View, Platform } from "../../core";
import Touchable from "../TouchableComponent";
import { commonStyles } from "../../assets/css/commonStyle";
import { commonFontStyles } from "../../assets/css/commonFontStyles";
import HtmlDeCode from "../../utils/HtmlDecode";

import attachedFileIcon from "../../assets/images/attachedFileIcon.png";

export default R14.connect(
  class DownloadComponent extends Component {
    downloadFile = async ({ item, pathid, threadId, messageId }) => {
      let base64Format = await this.props.app.dm.billDetails.getDownloadAttachment(pathid, threadId, messageId, "simpleMessage");
      const fileObj = {
        content: `${Platform.OS === 'web' ? 'data:application/octet-stream;base64,' : ''}${(base64Format && base64Format.data) ? base64Format.data : base64Format}`,
        contentType: item.contentType,
        filename: item.fileName
      };
      HtmlDeCode.downloadFile(fileObj);
    };

    render() {
      const { item } = this.props;
      return (
        <>
          {!!item.attachments && !!item.attachments.length
            ? item.attachments.map((el, i) => (
                <Touchable
                  key={`download_${i}`}
                  onPress={() => {
                    this.downloadFile({
                      item: el,
                      pathid: el.path,
                      threadId: item.envelope.threadHeader.threadId,
                      messageId: item.envelope.messageHeader.messageId,
                    });
                  }}
                style={[commonStyles.marginBottom5]}>
                  <View style={[commonStyles.flex1, commonStyles.flexDirectionRow, commonStyles.alignItemsStart]}>
                    <Image source={attachedFileIcon} style={[commonStyles.icon14, styles.attachedFileIcon]} />
                    <Text style={[commonStyles.smallHeading, commonFontStyles.workSans]}>
                      {el.fileName || el.filename}
                    </Text>
                  </View>
                </Touchable>
              ))
            : null}
        </>
      );
    }
  }
);
const styles = StyleSheet.create({
  attachedFileIcon: {
    marginTop: 3,
    marginRight: 5,
  },
});
